module.exports = __webpack_public_path__ + "img/bg_mobile_de.91a7ac6d.jpg";